<template>
    <div id="konfigurator-rasa">
        <h1>Plemeno</h1>

        <div v-show="(!isValidRasa() || !isValidVelikost()) && tryEscape" class="info-messages-box">
            <div v-if="!isValidRasa() && tryEscape" class="error-msg">Musíte vybrat plemeno</div>
            <div v-if="!isValidVelikost() && tryEscape" class="error-msg">Musíte vybrat velikost</div>
        </div>

        <div class="form-content">

            <div class="rasa-krizenec">
                <div class="form-radios">
                    <div class="form-type-radio" :key="key" v-for="(item, key) in rasaTypItems">
                        <input type="radio" @change="changeTyp(item.val)" v-model="mazlicek.rasa.typ"
                               v-bind:value="item.val"
                               :id="item.val">
                        <label :for="item.val">
                            {{ item.title }}
                        </label>

                    </div>
                </div>
            </div>

            <div class="rasa-krizenec-vyber"
                 v-bind:class="{ 'has-error':!isValidRasa() && tryEscape }">
                <autocomplete
                        :keyword="mazlicek.rasa.autocomplete.keyword"
                        :options="rasaItems"
                        @select="rasaSelect"
                        v-if="mazlicek.rasa.typ === 'app_rasa'"
                >
                </autocomplete>

                <div class="form-radios" v-if="mazlicek.rasa.typ === 'app_velikost'"
                     v-bind:class="{ 'has-error':!isValidVelikost() && tryEscape }">
                    <h2 class="konf-subtitle">Vyberte nejbližší:</h2>
                    <div class="form-type-radio" :key="key" v-for="(item, key) in velikostItems">
                        <input type="radio" @change="changeSizePriceRatio" v-model="mazlicek.rasa.velikost" v-bind:value="item.id" :id="item.id">
                        <label :for="item.id">
                            <div class="item-title">{{ item.title }}</div>
                            <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <info :krok="2"></info>

        <confirmation-modal v-if="priceConfirmation.showModal"
                            :old-price="priceConfirmation.oldPrice" :new-price="priceConfirmation.newPrice"
                            :confirm-callback="updatePetAndQuit" @close="priceConfirmation.showModal = false"/>
        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>
</template>

<script>
import {apiSilex} from '../api'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import autocomplete from './Autocomplete'
import navigace from './Navigace'
import info from './Info'
import imageService from '../services/image-service'
import ConfirmationModal from "./ConfirmationModal";

export default {
        components: {
            ConfirmationModal,
            autocomplete, navigace, info
        },
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                rasaTypItems: [
                    {title: 'Znám plemeno', val: 'app_rasa'},
                    {title: 'Neznám plemeno', val: 'app_velikost'}
                ],
                rasaItems: [],
                velikostItems: [],
                emptykrizenec: this.$store.state.mazlicek.jmeno.value !== null,
                tryEscape: false,
                priceConfirmation: {
                    showModal: false,
                    differentPrice: false,
                    oldPrice: 0,
                    newPrice: 0,
                }
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.rasa.valid = !this.$v.rasaValid.$invalid)
            }
        },
        methods: {
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            isValidRasa: function () {
                let mazlicekRasa = this.mazlicek.rasa
                let isValid
                if (mazlicekRasa.typ === 'app_rasa') {
                    isValid = mazlicekRasa.autocomplete.keyword.length !== 0 && mazlicekRasa.id.length !== null
                } else {
                    isValid = true
                }
                return isValid
            },
            isValidVelikost: function () {
                let mazlicekRasa = this.mazlicek.rasa
                let isValid
                if (mazlicekRasa.typ === 'app_velikost') {
                    isValid = mazlicekRasa.velikost !== null
                } else {
                    isValid = true
                }
                return isValid
            },
            validateComplete: function () {
                return this.isValidVelikost() && this.isValidRasa()
            },
            changeTyp: function (val) {
                // this.mazlicek.rasa.id = null
                // this.mazlicek.rasa.autocomplete.keyword = ''
                this.tryEscape = false
            },
            rasaSelect: function (val) {
                this.mazlicek.rasa.id = val.id
                this.mazlicek.rasa.autocomplete.keyword = val.title
                const rasa = this.rasaItems.find(item => item.id == this.mazlicek.rasa.id)
                const velikost = this.velikostItems.find(item => item.id == rasa.id_velikost)

              this.mazlicek.rasa.priceRatio = velikost.koeficient_ceny
            },
            changeSizePriceRatio: function(){
              let ratio = 1
              if(this.mazlicek.rasa.velikost){
                const velikost = this.velikostItems.find(item => item.id == this.mazlicek.rasa.velikost)
                ratio = velikost.koeficient_ceny
              }

              this.mazlicek.rasa.priceRatio = ratio
            },
            prev: function () {
                this.$router.push({name: 'jmenomazlicka'})
            },
            next: function () {
                if (this.validateComplete()) {
                    if (this.mazlicek.rasa.typ === 'app_velikost') {
                        this.mazlicek.rasa.autocomplete.keyword = ''
                        this.mazlicek.rasa.id = null
                    } else {
                        this.mazlicek.rasa.velikost = null
                    }

                    if (this.mazlicek.rasa.id) {
                        apiSilex.get('/rasa?id=' + this.mazlicek.rasa.id).then((response) => {
                            const val = response.data[0]
                            const _that = this

                            const raceImage = val.rasa_obrazek_url !== ""  ?
                                val.rasa_obrazek_url : imageService.RACE_ORIGINAL_IMAGES_URL + val.title_en + '.png'

                            var xhr = new XMLHttpRequest()

                            xhr.onload = function () {
                                imageService
                                    .createBase64Image(xhr.response)
                                    .then(base64Image => {
                                        _that.mazlicek.fotografie.icnValue = base64Image
                                    })
                            }
                            xhr.open('GET', raceImage)
                            xhr.responseType = 'blob'
                            xhr.send()
                        })
                    } else if(this.mazlicek.rasa.velikost) {
                        const _that = this

                        const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-new-' + this.mazlicek.rasa.velikost + '.svg'

                        var xhr = new XMLHttpRequest()

                        xhr.onload = function () {
                            imageService
                                .createBase64Image(xhr.response)
                                .then(base64Image => {
                                    _that.mazlicek.fotografie.icnValue = base64Image
                                })
                        }
                        xhr.open('GET', raceImage)
                        xhr.responseType = 'blob'
                        xhr.send()
                    }

                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.$router.push({name: 'narozeniny'})
                        }, error => {
                            console.error(error)
                        })
                    this.mazlicek.rasa.valid = true
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            saveAndQuit: function () {
              if (this.validateComplete()) {
                if (this.mazlicek.rasa.typ === 'app_velikost') {
                  this.mazlicek.rasa.autocomplete.keyword = ''
                  this.mazlicek.rasa.id = null
                } else {
                  this.mazlicek.rasa.velikost = null
                }

                this.mazlicek.confirmToSave = true
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    const confirmation = response.data.data.priceConfirmation;
                    if (confirmation && confirmation.differentPrice) {
                        this.priceConfirmation.oldPrice = confirmation.oldPrice;
                        this.priceConfirmation.newPrice = confirmation.newPrice;
                        this.priceConfirmation.showModal = true
                    } else {
                        this.updatePetAndQuit()
                    }
                  }, error => {
                    console.error(error)
                  }).finally(() => {
                      this.mazlicek.confirmToSave = false
                  })
                this.mazlicek.rasa.valid = true

              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            },
            updatePetAndQuit() {
                this.mazlicek.confirmToSave = false
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
            }
        },
        validations: {
            mazlicek: {
                rasa: {
                    id: {},
                    velikost: {}
                }
            },
            rasaValid() {
                return required(this.mazlicek.rasa.id) || required(this.mazlicek.rasa.velikost)
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 2
            this.$cookies.set('lastVisitedStep', 2)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            apiSilex.get('/rasa').then(
                response => (this.rasaItems = response.data)
            )
            apiSilex.get('/velikost').then(
                response => (this.velikostItems = response.data)
            )
        },
    }
</script>



// WEBPACK FOOTER //
// 02Rasa.vue?f4b99fa6